import './styles.scss';

import { DATE_FE_FORMAT, TIME_FORMAT } from '@/constants';
import { Datetime, getClasses } from 'utils';
import { InputGroup, InputGroupProps } from 'react-bootstrap';

import DateInput from 'components/DateInput';
import { InputProps } from '@/components/Input';
import TimeInput from 'components/TimeInput';
import { fieldWrapper } from '@/components/Field';
import { useMemo } from 'react';

export type DatetimeInputProps = {
  value: string;
  disabled?: boolean | [boolean?, boolean?];
} & InputGroupProps &
  Omit<InputProps, 'disabled'>;

const DatetimeInput = ({
  name,
  value,
  onChange,
  disabled,
  isValid,
  isInvalid,
  isDirty,
  ...inputGroupProps
}: DatetimeInputProps): JSX.Element => {
  const datetime = useMemo((): Datetime => new Datetime(value), [value]);

  const handleDateChange = (date) => {
    if (Array.isArray(date)) date = date[0];
    if (!date) return;
    datetime.setDate(date);
    onChange(datetime.toString());
  };
  const handleTimeChange = (event) => {
    const { value: time } = event?.target || {};
    console.log('TIME', time);
    if (!time) return;
    datetime.setTime(time);
    onChange(datetime.toString());
  };

  return (
    <InputGroup {...inputGroupProps} className={getClasses('DatetimeInput', inputGroupProps.className)} name={name ? name : undefined}>
      <DateInput.New
        name={name ? `${name}-DateInput` : undefined}
        value={[value ? datetime.format(DATE_FE_FORMAT) : '']}
        onChange={handleDateChange}
        placeholder="--/--/--"
        disabled={disabled === true || disabled?.[0] === true}
      />
      <TimeInput
        name={name ? `${name}-TimeInput` : undefined}
        value={value ? datetime.format(TIME_FORMAT) : ''}
        onChange={handleTimeChange}
        suffixIcon={null}
        disabled={disabled === true || disabled?.[1] === true}
      />
    </InputGroup>
  );
};

export const DatetimeInputField = fieldWrapper<DatetimeInputProps>(DatetimeInput);

export default DatetimeInput;
